<template>
  <div class="d-flex min-height align-items-center">
    <vue-headful title="Login" />
    <Header page_title="Login" />
    <div class="container-fluid px-4 mx-2 pb-4 mb-4">
      <form @submit.prevent="onSubmit">
        <p>
          <strong>Welkom bij Derect!</strong>
        </p>
        <NotificationContainer />
        <div class="form-group">
          <input
            type="email"
            v-model="form.email"
            class="form-control"
            placeholder="E-mailadres"
            required
            autocomplete="nope"
          />
        </div>
        <div class="pb-1">
          <div class="form-group w-square-icon mb-4">
            <input
              v-bind:type="[!pass ? 'text' : 'password']"
              v-model="form.password"
              class="form-control"
              placeholder="Wachtwoord"
              required
              autocomplete="nope"
            />
            <div
              class="icon-wrapper eye position-absolute align-self-center"
              v-on:click="pass = false"
              v-if="pass"
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <svg-icon icon="eye" />
            </div>
            <div
              class="icon-wrapper eye shown position-absolute align-self-center"
              v-on:click="pass = true"
              v-else
              v-ripple="'rgba(255, 255, 255, 0.35)'"
            >
              <span><svg-icon icon="eye_hidden" /></span>
            </div>
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-warning btn-block mb-3"
          v-ripple="'rgba(255, 255, 255, 0.35)'"
        >
          Login
        </button>
        <div class="text-center small">
          <router-link
            :to="{ name: 'forgot-password' }"
            class="text-derect"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            <strong>Wachtwoord vergeten?</strong>
          </router-link>
        </div>
      </form>
    </div>
    <footer class="position-fixed w-100">
      <div class="container-fluid text-center">
        <p class="py-4 my-1">
          <router-link
            :to="{ name: 'choose-branch' }"
            title="Heb je nog geen account? Registreer hier"
            class="text-derect"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Heb je nog geen account?
            <strong>Registreer hier</strong>
          </router-link>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      center: true,
      form: {
        app_id: "fake-app-id-3940256099942544~3347511713",
        email: "",
        password: ""
      },
      pass: true,
      social: true
    };
  },
  props: [
    "token",
    "redirectTo"
  ],
  async created() {},
  async mounted() {
    if (localStorage.getItem("user-token")) {
      this.$router.replace({
        name: this.redirectTo
      });
    }
    else
      await this.loginWithUserToken();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      if (localStorage.getItem("user-login")) {
        let user_login = JSON.parse(localStorage.getItem("user-login"));
        this.form.email = user_login.email ? user_login.email : "";
      }
      this.$store.state.loading = false;
    },
    async onSubmit() {
      this.$store.state.loading = true;
      await this.verifyUserEmail(this.form.email);
      await this.loginUser(this.form);
      await this.userToken();
    },
    async loginWithUserToken() {
      this.$store.state.loading = true;
      
      try {
        localStorage.setItem("user-time", JSON.stringify(new Date()));
        localStorage.setItem("user-token", JSON.stringify(this.token));
        await this.userToken(this.redirectTo);
        this.$store.state.loading = false;
      } catch (e) {
        // console.log(error);
        this.$store.state.loading = false;
        localStorage.removeItem("user-time");
        localStorage.removeItem("user-token");
        const notification = {
          type: "danger",
          message: "Er is een fout opgetreden, waarschijnlijk is de link die je hebt gebruikt verlopen. Hieronder kun je inloggen.",
          noTryAgain: true
        };
        this.$store.dispatch("notification/replace", notification, {
          root: true
        });
      }
    }
  }
};
</script>

<style scoped>
::v-deep body.bg-image #app {
  color: red;
}
</style>
